import React from 'react';
import SearchIcon from './icons/SearchIcon';

// This component renders an input field, used as search field, and search icon
// Basic process: 
//  1) user types value into the input field
//  2) onChange handler gets called when user types in value into input field and value is saved in local state
//  3) when component renders, its "value" is set to the value that was saved in the local state.
//  4) When user hits onSubmit, the callers onSubmit function is called. The caller handles the search logic, 
//     and it clears the searchValue in SearchField component by calling the function(s) that were 
//     registered on the  parent. The functions are registered with the parent in the componentDidMount.
//     Here we call the regisrationFunction passed from parent via props.
//
// Props Required:
//  Need to pass in function the "onSubmit" that will conduct the search.
//  Need to pass in registration function. 
//
// Note that the onsubmit button is an icon (magnifying glass). The icon can be replaced
// with text, another icon, or button of choice.
export class SearchField extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchValue: ''
        }
    }

    // This calls the parents onSubmit function, Which will conduct the search
    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit(e);
    }

    // This calls the parents onChange handler, Which will conduct the search
    onChangeHandler =  (e) =>  {
        let searchValue = e.target.value;
        this.setState({searchValue});
    }

    // Lifecyle method is used to call the parents registration function
    // so parent can register the getSearchValue and clearSearchValue functions in their local state.
    componentDidMount = () => {
        this.props.registrationFunction(this.getSearchValue, this.clearSearchValue);
    }


    // The Following two functions are registered with the parent via the 
    // registrationFunction passed via props.
    getSearchValue = () => {
        return this.state.searchValue;
    }
    // This is function is registered with the parent
    clearSearchValue = () => {
        this.setState({searchValue: ''})
    }

    render() {
        return (
            <form className="searchfield_form" onSubmit={this.onSubmit} >
                <input  className="searchfield-form__input"
                    type="text"
                    placeholder="Search"
                    onChange={this.onChangeHandler}  // Handler called to update the state with whats entered in input field
                    value={this.state.searchValue}         // value to render component with (from value of state updated onChangeHandler
                />
                <button className="search-button">
                    <SearchIcon />
                </button> 
            </form>
        )
    }
}

export default SearchField;




// WEBPACK FOOTER //
// ./src/components/SearchField.js